interface PageHeaderProps {
  eyebrow: string;
  title: string;
  /** Optional standfirst under the title. */
  intro?: React.ReactNode;
  /** Optional content below the intro (e.g. stat strip). */
  children?: React.ReactNode;
  /** Constrain text width; full-bleed pages (e.g. maps) pass false. */
  narrow?: boolean;
}

// Single source of truth for page header rhythm so About / Partnership /
// Events / Geography share identical eyebrow→title→intro gaps.
export const PageHeader = ({
  eyebrow,
  title,
  intro,
  children,
  narrow = true,
}: PageHeaderProps) => (
  <section className="pt-10 pb-6 md:pt-16 md:pb-10">
    <div className="container mx-auto px-4 md:px-8">
      <div className={narrow ? "max-w-2xl" : undefined}>
        <div className="text-xs font-bold uppercase tracking-widest text-brand-orange mb-3">
          {eyebrow}
        </div>
        <h1 className="text-3xl md:text-5xl font-black tracking-tight text-foreground">
          {title}
        </h1>
        {intro && (
          <div className="mt-3 text-base leading-relaxed text-muted-foreground">
            {intro}
          </div>
        )}
        {children}
      </div>
    </div>
  </section>
);
